// Navbar.jsx
import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import ProgressBar from '../progress-bar/progress-bar';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import manheimLogo from './manheim-logo.svg';
import Icon from '../icon/icon';
import { HOME_ROUTE, LOG_IN_ROUTE } from '../../constants/constants';

class Navbar extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			showLangDropdown: false
		};
		this.goToHomePage = this.goToHomePage.bind(this);
		this.onChangeLanguage = this.onChangeLanguage.bind(this);
		this.onLogOutClick = this.onLogOutClick.bind(this);
		this.toggleLangDropdown = this.toggleLangDropdown.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.handleLangKeyDown = this.handleLangKeyDown.bind(this);
		this.handleToggleKeyDown = this.handleToggleKeyDown.bind(this);

	}

	componentDidMount () {
		document.addEventListener('mousedown', this.handleOutsideClick);
	}

	componentWillUnmount () {
		document.removeEventListener('mousedown', this.handleOutsideClick);
	}

	handleOutsideClick (event) {
		if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
			this.setState({ showLangDropdown: false });
		}
	}

	toggleLangDropdown () {
		this.setState((prev) => ({ showLangDropdown: !prev.showLangDropdown }));
	}

	goToHomePage () {
		this.props.clearParentState();
		this.props.setRoute(HOME_ROUTE);
	}

	onLogOutClick () {
		this.props.clearParentState();
		this.props.setRoute(LOG_IN_ROUTE);
	}

	onChangeLanguage (language) {
		this.setState({ showLangDropdown: false });
		this.props.setParentState({ language });
	}

	handleLangKeyDown (e, current) {
		if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
			e.preventDefault();
			const next = current === 'EN' ? this.langOptionES : this.langOptionEN;
			const prev = current === 'ES' ? this.langOptionEN : this.langOptionES;

			const target = e.key === 'ArrowDown' ? next : prev;
			if (target && target.focus) {
				target.focus();
			}
		} else if (e.key === 'Enter' || e.key === '') {
			e.preventDefault();
			this.onChangeLanguage(current);
		} else if (e.key === 'Escape') {
			e.preventDefault();
			this.setState({ showLangDropdown: false });
		}
	}

	handleToggleKeyDown (e) {
		if (e.key === 'ArrowDown') {
			e.preventDefault();
			this.setState({ showLangDropdown: true }, () => {
				if (this.langOptionEN && this.langOptionEN.focus) {
					this.langOptionEN.focus();
				}
			});
		}
	}

	render () {
		const __ = mergeI18n(this.props.language, i18n);
		const currentLang = this.props.language === 'EN' ? 'English' : 'Español';

		const logoClassNames = classnames({
			'site-logo': true,
			enabled: this.props.canGoToHomePage
		});

		return (
			<div>
				<nav className='lss-navbar'>
					<div className='container-fluid'>
						<div className='navbar-header'>
							<img
								className={logoClassNames}
								onClick={() => this.props.canGoToHomePage && this.goToHomePage()}
								src={manheimLogo}
								alt={__.siteLogoHint}
							/>
						</div>
						<ul className='nav navbar-nav navbar-right hidden-xs'>
							<li
								className={`language-dropdown ${
									this.state.showLangDropdown ? 'open' : ''
								}`}
								ref={(ref) => { this.dropdownRef = ref; }}
							>
								<button
									className='dropdown-toggle'
									onClick={this.toggleLangDropdown}
									onKeyDown={this.handleToggleKeyDown}
									tabIndex={0}
									aria-haspopup='true'
									aria-expanded={this.state.showLangDropdown}
								>
									<Icon name='MdLanguage' align='top' /> {currentLang}{' '}
									<span className='caret' />
								</button>
								{this.state.showLangDropdown && (
									<ul className='dropdown-menu'>
										<li>
											<a
												tabIndex={0}
												role='menuitem'
												ref={(el) => { this.langOptionEN = el; }}
												onKeyDown={(e) => this.handleLangKeyDown(e, 'EN')}
												onClick={() => this.onChangeLanguage('EN')}
											>
												English
											</a>
										</li>
										<li>
											<a
												tabIndex={0}
												role='menuitem'
												ref={(el) => { this.langOptionES = el; }}
												onKeyDown={(e) => this.handleLangKeyDown(e, 'ES')}
												onClick={() => this.onChangeLanguage('ES')}
											>
												Español
											</a>
										</li>
									</ul>
								)}
							</li>
							{this.props.canLogOut && (
								<li>
									<button
										className='btn btn-default logout'
										onClick={this.onLogOutClick}
									>
										{__.logOut}
									</button>
								</li>
							)}
						</ul>
					</div>
				</nav>
				<ProgressBar
					isLoading={this.props.isLoading}
					language={this.props.language}
					progressIndex={this.props.progressIndex}
				/>
			</div>
		);
	}
}

Navbar.propTypes = {
	language: propTypes.string,
	canGoToHomePage: propTypes.bool,
	canLogOut: propTypes.bool,
	progressIndex: propTypes.number,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired,
	clearParentState: propTypes.func.isRequired
};

export default Navbar;
